<template>
  <div class="sceneHistoryContain">
    <div class="mainContent" :style="styleObject">
      <div class="btn-box">
        <el-button @click="handleGoBack">返回</el-button>
      </div>
      <div class="tableBox contentShowArea">
        <border-table :loading="DatasLoading" :tableData="DataList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleDataCurrentChange" @sizeChange="handleDataSizeChange">
          <el-table-column prop="sceneName" label="联动名称"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
          <el-table-column prop="isEnabled" label="状态">
            <template #default="{row}">
              <span
                class="is-delete"
                :style="{ color: row.isEnabled ? '#13CE66' : '#FF4949'}">
                {{row.isEnabled ? '启用' : '禁用'}}
              </span>
              <el-switch
                v-model="row.isEnabled"
                @change="handleSwithChange($event, row.id)"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </template>
          </el-table-column>
        </border-table>
      </div>
    </div>
  </div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
export default {
  components: {
    BorderTable,
    // OneGroupCheckboxs
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      DatasLoading: false,
      DataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.makeheight()
  },
  mounted() {},
  methods: {
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    /**
     * @Description 返回
     * @Author      YOYO     -             2022-09-21
     */
    handleGoBack () {
      this.$router.go(-1)
    },
    /**
     * @Description 切换列表页数
     * @Author      YOYO     -             2022-07-05
     */
    handleDataCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.queryDataList();
    },
    /**
     * @Description 切换列表分页大小
     * @Author      YOYO     -             2022-07-05
     */
    handleDataSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
  }
};
</script>

<style lang="scss" scoped>
.sceneHistoryContain {
  margin: 12px;
  padding: 15px 0;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .btn-box {
    height: 32px;
    .el-button {
      float: right;
    }
    padding: 0 20px 20px
  }
  .tableBox {
    padding: 0 20px
  }
}
</style>
<style lang="scss">
.addSceneContain {
}
</style>
